import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelText as _vModelText, resolveComponent as _resolveComponent, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4831c09a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filters-container" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Date Range", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "all" }, "All Time", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "today" }, "Today", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "week" }, "Last 7 Days", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "month" }, "Last 30 Days", -1))
const _hoisted_8 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Sort By", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "dateCreated" }, "Date Created", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "roleTitle" }, "Job Title", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "companyName" }, "Company Name", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "applicationStatus" }, "Status", -1))
const _hoisted_15 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Sort Direction", -1))
const _hoisted_18 = { value: "desc" }
const _hoisted_19 = { value: "asc" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/media/jobbuddymascot.png",
  alt: "JobBuddy Mascot",
  class: "onboarding-mascot mb-3"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "welcome-message mb-2" }, "Ready to land your dream job?", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted small mb-3" }, "Follow these simple steps to get started with JobBuddy", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "onboarding-steps mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "step" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "step-icon" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle-fill" })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "step-content" }, [
      /*#__PURE__*/_createElementVNode("h5", null, "Create an Application"),
      /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "Start here to unlock all features")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "step" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "step-icon" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-text-fill" })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "step-content" }, [
      /*#__PURE__*/_createElementVNode("h5", null, "Generate Documents"),
      /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "Get AI-powered cover letters and resumes")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "step" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "step-icon" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-workspace" })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "step-content" }, [
      /*#__PURE__*/_createElementVNode("h5", null, "Practice Interviews"),
      /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "Prepare with AI interview simulations")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "step" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "step-icon" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "bi bi-graph-up" })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "step-content" }, [
      /*#__PURE__*/_createElementVNode("h5", null, "Track Progress"),
      /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "Monitor your application journey")
    ])
  ])
], -1))
const _hoisted_24 = { class: "dashboard-container" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile-notice d-md-none mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "alert alert-info mb-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle me-2" }),
    /*#__PURE__*/_createTextVNode(" JobBuddy works best on a desktop. We're working on a mobile version! ")
  ])
], -1))
const _hoisted_26 = { class: "dashboard-header mb-4" }
const _hoisted_27 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_28 = { class: "status-pills" }
const _hoisted_29 = { class: "count" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "count" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1))
const _hoisted_33 = { class: "d-flex gap-2 mb-4" }
const _hoisted_34 = { class: "search-box flex-grow-1" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search" }, null, -1))
const _hoisted_36 = {
  key: 0,
  class: "card border-0 shadow-sm applications-table"
}
const _hoisted_37 = { class: "table-responsive" }
const _hoisted_38 = { class: "table table-hover mb-0" }
const _hoisted_39 = { class: "sticky-top bg-white" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "skeleton-text" })
], -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "skeleton-text" })
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "skeleton-badge" })
], -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "skeleton-text",
    style: {"width":"80px"}
  })
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end pe-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "skeleton-icon" })
], -1))
const _hoisted_46 = [
  _hoisted_41,
  _hoisted_42,
  _hoisted_43,
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 0,
  class: "status-dropdown"
}
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "text-end pe-4" }
const _hoisted_51 = { class: "dropdown" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-icon",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots-vertical" })
], -1))
const _hoisted_53 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_54 = { class: "w-100" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash me-2" }, null, -1))
const _hoisted_57 = {
  key: 1,
  class: "empty-state text-center py-5 h-100"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-state-icon mb-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clipboard-plus display-1 text-muted" })
], -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-3" }, "No Applications Yet", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-4" }, "Start by creating your first application.", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus" }, null, -1))

import { ref, onMounted, computed } from "vue";
import { useAuth0 } from "@auth0/auth0-vue";
import FileUpload from "@/components/FileUpload.vue";
import store from "@/store";
import { UserApplicationListItem } from "@models/dtos/UserApplicationList";
import { ApplicationApiService } from "@/services/ApplicationApiService";
import Document from "@models/Document";
import Modal from "@/components/Modal.vue";
import { toast } from "vue3-toastify";
import router from "../router";
import { ApplicationStatus } from "@models/SystemEnums";
import confetti from "canvas-confetti";
import CreateApplication from "@/views/CreateApplication.vue";

type SortableField = "roleTitle" | "companyName" | "applicationStatus" | "dateCreated";


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props) {

const documentsList = ref<Document[]>();
const user = ref({});
user.value = useAuth0().user;
const applicationsList = ref(new Array<UserApplicationListItem>());

const errorModal = ref<InstanceType<typeof Modal> | null>(null);
const appDeleteModal = ref<InstanceType<typeof Modal> | null>(null);
const docDeleteModal = ref<InstanceType<typeof Modal> | null>(null);
const filtersModal = ref<InstanceType<typeof Modal> | null>(null);
const onboardingModal = ref<InstanceType<typeof Modal> | null>(null);
const loading = ref(true);

let applicationIdToDelete = "";
let documentIdToDelete = "";
onMounted(async () => {
  store.dispatch("toggleLoader", true);
  await loadUserApplications();
  await loadUserDocuments();
  store.dispatch("toggleLoader", false);
  if (user.value.value.email_verified === false) {
    router.push("/verifyEmail");
    return;
  }
  if (applicationsList.value.length === 0) {
    onboardingModal.value?.show();
  }
  if (documentsList.value?.length == 0 && applicationsList.value.length == 0) {
    console.log("No documents or applications");
  }
});

async function loadUserDocuments() {
  //Don't load documents uneccessarily
  await store.dispatch("documents/loadDocuments");
  documentsList.value = store.getters["documents/getDocuments"];
  loading.value = false;
}

function confirmDeleteApplication(applicationId: number) {
  applicationIdToDelete = applicationId;
  appDeleteModal.value.show();
}

const showCreateApplicationModal = ref(false);

function createFirstApplication() {
  if (onboardingModal.value) {
    onboardingModal.value.hide();
  }
  showCreateApplicationModal.value = true;
}

function onApplicationCreated(applicationId: string) {
  showCreateApplicationModal.value = false;
  loadUserApplications();
  router.push(`/application/${applicationId}`);
}

async function deleteApplication() {
  appDeleteModal.value.hide();
  if (!applicationIdToDelete) return;
  const result = await ApplicationApiService.delete(applicationIdToDelete);
  if (result.status == 200) {
    applicationsList.value = applicationsList.value.filter(
      (app) => app.applicationId != applicationIdToDelete
    );
    toast.success("Application deleted successfully");
  } else {
    errorModal.value.show();
    toast.error("Application could not be deleted");
  }
  applicationIdToDelete = "";
}

async function loadUserApplications() {
  const response = await ApplicationApiService.getUserApplicationList();
  if (response.status == 200) {
    applicationsList.value = response.data.applications;
  }
}

async function handleCVUpload(event) {
  console.log(event);
  await postDocuments(event);
  toast.success("Document uploaded successfully");
}

async function postDocuments(file) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("userId", user.value.value.sub);
  await store.dispatch("documents/uploadResume", formData);
  await loadUserDocuments();
}

function goToTaskboard() {
  router.push("/taskboard");
}
function confirmDocDelete(documentId: string) {
  documentIdToDelete = documentId;
  docDeleteModal.value.show();
}

async function deleteDocument() {
  if (!documentIdToDelete) return;
  await store.dispatch("documents/deleteDocument", documentIdToDelete);
  await loadUserDocuments();
  documentIdToDelete = "";
  docDeleteModal.value.hide();
  toast.success("Document deleted successfully");
}

const activeStatus = ref<"all" | ApplicationStatus>("all");
const searchQuery = ref("");
const filters = ref({
  dateRange: "all",
});

const isFilterActive = computed(() => {
  return filters.value.dateRange !== "all";
});

function applyFilters() {
  filtersModal.value.hide();
}

function clearFilters() {
  filters.value.dateRange = "all";
  sortField.value = "dateCreated";
  sortDirection.value = "desc";
}

const formatDate = (date: string) => {
  return new Date(date).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

const getStatusCount = (status: ApplicationStatus) => {
  return applicationsList.value.filter((app) => app.applicationStatus === status).length;
};

const formatStatus = (status: ApplicationStatus | string) => {
  if (typeof status === "string") {
    return status
      ?.split("_")
      .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
      .join(" ");
  }
  return ApplicationStatus[status]
    ?.split("_")
    .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
    .join(" ");
};

const getStatusClass = (status: ApplicationStatus) => {
  const statusClasses = {
    [ApplicationStatus.TO_APPLY]: "to-apply",
    [ApplicationStatus.APPLIED]: "applied",
    [ApplicationStatus.INTERVIEWING]: "interviewing",
    [ApplicationStatus.REJECTED]: "rejected",
    [ApplicationStatus.OFFERED]: "offered",
  };
  return statusClasses[status];
};

const sortField = ref<SortableField>("dateCreated");
const sortDirection = ref<"asc" | "desc">("desc");

function toggleSort(field: SortableField) {
  if (sortField.value === field) {
    sortDirection.value = sortDirection.value === "asc" ? "desc" : "asc";
  } else {
    sortField.value = field;
    sortDirection.value = "desc";
  }
}

function getSortIcon(field: SortableField) {
  if (sortField.value !== field) return "bi bi-arrow-down-up text-muted";
  return sortDirection.value === "asc" ? "bi bi-arrow-up-short" : "bi bi-arrow-down-short";
}

const filteredApplications = computed(() => {
  return applicationsList.value
    .filter((app) => {
      const matchesStatus =
        activeStatus.value === "all" || app.applicationStatus === activeStatus.value;
      const matchesSearch =
        app.roleTitle?.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
        app.companyName?.toLowerCase().includes(searchQuery.value.toLowerCase());

      // Add date range filtering
      const matchesDateRange = (() => {
        if (filters.value.dateRange === "all") return true;
        const appDate = new Date(app.dateCreated);
        const now = new Date();
        let weekAgo, monthAgo;

        switch (filters.value.dateRange) {
          case "today":
            return appDate.toDateString() === now.toDateString();
          case "week":
            weekAgo = new Date(now.setDate(now.getDate() - 7));
            return appDate >= weekAgo;
          case "month":
            monthAgo = new Date(now.setDate(now.getDate() - 30));
            return appDate >= monthAgo;
          default:
            return true;
        }
      })();

      return matchesStatus && matchesSearch && matchesDateRange;
    })
    .sort((a, b) => {
      const aValue = a[sortField.value];
      const bValue = b[sortField.value];

      if (sortField.value === "dateCreated") {
        const dateA = new Date(aValue as string).getTime();
        const dateB = new Date(bValue as string).getTime();
        return sortDirection.value === "asc" ? dateA - dateB : dateB - dateA;
      }

      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortDirection.value === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      return 0;
    });
});

const statusValues = computed(() => [
  ApplicationStatus.TO_APPLY,
  ApplicationStatus.APPLIED,
  ApplicationStatus.INTERVIEWING,
  ApplicationStatus.REJECTED,
  ApplicationStatus.OFFERED,
]);

const showStatusDropdown = ref<{ [key: string]: boolean }>({});

async function updateApplicationStatus(applicationId: string, newStatus: ApplicationStatus) {
  try {
    const response = await ApplicationApiService.updateApplicationStatus(
      applicationId,
      newStatus,
      0
    );
    if (response.status === 200) {
      // Update the application status in the local list
      const app = applicationsList.value.find((app) => app.applicationId === applicationId);
      if (app) {
        app.applicationStatus = newStatus;
      }
      showStatusDropdown.value[applicationId] = false;

      // Trigger confetti if status is changed to offered
      if (newStatus === ApplicationStatus.OFFERED) {
        confetti({
          particleCount: 150,
          spread: 100,
          origin: { y: 1 },
        });
      }
    } else {
      throw new Error("Failed to update status");
    }
  } catch (error) {
    console.error("Error updating application status:", error);
    toast.error("Failed to update status");
  }
}

onMounted(() => {
  document.addEventListener("click", (e: MouseEvent) => {
    const target = e.target as HTMLElement;
    if (!target?.closest(".status-badge")) {
      Object.keys(showStatusDropdown.value).forEach((key) => {
        showStatusDropdown.value[key] = false;
      });
    }
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Modal, {
      title: "There's been an error!",
      ref_key: "errorModal",
      ref: errorModal
    }, {
      body: _withCtx(() => [
        _createTextVNode("There was an error processing this request. Please try again later!")
      ]),
      _: 1
    }, 512),
    _createVNode(Modal, {
      title: "Are you sure you want to delete this application?",
      ref_key: "appDeleteModal",
      ref: appDeleteModal
    }, {
      body: _withCtx(() => [
        _createTextVNode("This action cannot be undone!")
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteApplication())),
          class: "btn btn-danger"
        }, "Delete")
      ]),
      _: 1
    }, 512),
    _createVNode(Modal, {
      title: "Are you sure you want to delete this document?",
      ref_key: "docDeleteModal",
      ref: docDeleteModal
    }, {
      body: _withCtx(() => [
        _createTextVNode("This action cannot be undone")
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (deleteDocument())),
          class: "btn btn-danger"
        }, "Delete")
      ]),
      _: 1
    }, 512),
    _createVNode(Modal, {
      title: "Filters",
      ref_key: "filtersModal",
      ref: filtersModal
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value.dateRange) = $event)),
              class: "form-select"
            }, _hoisted_8, 512), [
              [_vModelSelect, filters.value.dateRange]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((sortField).value = $event)),
              class: "form-select"
            }, _hoisted_15, 512), [
              [_vModelSelect, sortField.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((sortDirection).value = $event)),
              class: "form-select"
            }, [
              _createElementVNode("option", _hoisted_18, _toDisplayString(sortField.value === "dateCreated" ? "Newest First" : "Z to A"), 1),
              _createElementVNode("option", _hoisted_19, _toDisplayString(sortField.value === "dateCreated" ? "Oldest First" : "A to Z"), 1)
            ], 512), [
              [_vModelSelect, sortDirection.value]
            ])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          onClick: applyFilters,
          class: "btn btn-primary"
        }, "Apply Filters")
      ]),
      _: 1
    }, 512),
    _createVNode(Modal, {
      ref_key: "onboardingModal",
      ref: onboardingModal,
      "hide-footer": ""
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", { class: "onboarding-content text-center" }, [
          _hoisted_20,
          _hoisted_21,
          _hoisted_22,
          _hoisted_23,
          _createElementVNode("div", { class: "mt-4" }, [
            _createElementVNode("button", {
              onClick: createFirstApplication,
              class: "btn btn-primary btn-lg px-4"
            }, " Create Your First Application ")
          ])
        ])
      ]),
      _: 1
    }, 512),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (showCreateApplicationModal.value)
        ? (_openBlock(), _createBlock(CreateApplication, {
            key: 0,
            show: showCreateApplicationModal.value,
            "is-modal": true,
            onClose: _cache[5] || (_cache[5] = ($event: any) => (showCreateApplicationModal.value = false)),
            onApplicationCreated: onApplicationCreated
          }, null, 8, ["show"]))
        : _createCommentVNode("", true)
    ])),
    _createElementVNode("div", _hoisted_24, [
      _hoisted_25,
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
              class: _normalizeClass(["status-pill", { active: activeStatus.value === 'all' }]),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (activeStatus.value = 'all'))
            }, [
              _createTextVNode(" All "),
              _createElementVNode("span", _hoisted_29, _toDisplayString(applicationsList.value.length), 1)
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusValues.value, (status) => {
              return (_openBlock(), _createElementBlock("button", {
                key: status,
                class: _normalizeClass(["status-pill", { active: activeStatus.value === status }]),
                onClick: ($event: any) => (activeStatus.value = status)
              }, [
                _createTextVNode(_toDisplayString(formatStatus(status)) + " ", 1),
                _createElementVNode("span", _hoisted_31, _toDisplayString(getStatusCount(status)), 1)
              ], 10, _hoisted_30))
            }), 128))
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary btn-md",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (showCreateApplicationModal.value = true))
          }, [
            _hoisted_32,
            _createTextVNode(" New Application ")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "Search applications...",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((searchQuery).value = $event))
          }, null, 512), [
            [_vModelText, searchQuery.value]
          ])
        ]),
        _createElementVNode("button", {
          class: _normalizeClass(["btn", {
          'btn-outline-secondary': !isFilterActive.value,
          'btn-primary': isFilterActive.value,
        }]),
          onClick: _cache[9] || (_cache[9] = ($event: any) => (isFilterActive.value ? clearFilters() : filtersModal.value?.show()))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["bi", { 'bi-funnel-fill': isFilterActive.value, 'bi-funnel': !isFilterActive.value }])
          }, null, 2),
          _createTextVNode(" " + _toDisplayString(isFilterActive.value ? "Clear Filters" : "Filters"), 1)
        ], 2)
      ]),
      (applicationsList.value.length > 0 || loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("table", _hoisted_38, [
                _createElementVNode("thead", _hoisted_39, [
                  _createElementVNode("tr", {
                    class: _normalizeClass({ 'text-secondary': !loading.value, 'text-gray-300': loading.value })
                  }, [
                    _createElementVNode("th", {
                      class: _normalizeClass(["sortable-header", { 'pointer-events-none': loading.value }]),
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (toggleSort('roleTitle')))
                    }, [
                      _createTextVNode(" Job Title "),
                      _createElementVNode("i", {
                        class: _normalizeClass([[getSortIcon('roleTitle'), { 'opacity-25': loading.value }], "sort-icon"])
                      }, null, 2)
                    ], 2),
                    _createElementVNode("th", {
                      class: _normalizeClass(["sortable-header", { 'pointer-events-none': loading.value }]),
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (toggleSort('companyName')))
                    }, [
                      _createTextVNode(" Company "),
                      _createElementVNode("i", {
                        class: _normalizeClass([[getSortIcon('companyName'), { 'opacity-25': loading.value }], "sort-icon"])
                      }, null, 2)
                    ], 2),
                    _createElementVNode("th", {
                      class: _normalizeClass(["sortable-header", { 'pointer-events-none': loading.value }]),
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (toggleSort('applicationStatus')))
                    }, [
                      _createTextVNode(" Status "),
                      _createElementVNode("i", {
                        class: _normalizeClass([[getSortIcon('applicationStatus'), { 'opacity-25': loading.value }], "sort-icon"])
                      }, null, 2)
                    ], 2),
                    _createElementVNode("th", {
                      class: _normalizeClass(["sortable-header", { 'pointer-events-none': loading.value }]),
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (toggleSort('dateCreated')))
                    }, [
                      _createTextVNode(" Created "),
                      _createElementVNode("i", {
                        class: _normalizeClass([[getSortIcon('dateCreated'), { 'opacity-25': loading.value }], "sort-icon"])
                      }, null, 2)
                    ], 2),
                    _hoisted_40
                  ], 2)
                ]),
                _createElementVNode("tbody", null, [
                  (loading.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(5, (i) => {
                        return _createElementVNode("tr", {
                          key: `skeleton-${i}`,
                          class: "skeleton-row"
                        }, _hoisted_46)
                      }), 64))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(filteredApplications.value, (app) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: app.applicationId
                        }, [
                          _createElementVNode("td", null, [
                            _createVNode(_component_router_link, {
                              to: { name: 'Application', params: { id: app.applicationId } },
                              class: "text-decoration-none text-body cell-link",
                              style: {"display":"block","width":"100%"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(app.roleTitle), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(app.companyName), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["status-badge", getStatusClass(app.applicationStatus)]),
                              onClick: ($event: any) => (
                    showStatusDropdown.value[app.applicationId] = !showStatusDropdown.value[app.applicationId]
                  )
                            }, [
                              _createTextVNode(_toDisplayString(formatStatus(app.applicationStatus)) + " ", 1),
                              (showStatusDropdown.value[app.applicationId])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusValues.value, (status) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: status,
                                        class: _normalizeClass(["status-option", { active: status === app.applicationStatus }]),
                                        onClick: _withModifiers(($event: any) => (updateApplicationStatus(app.applicationId, status)), ["stop"])
                                      }, _toDisplayString(formatStatus(status)), 11, _hoisted_49))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ], 10, _hoisted_47)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(formatDate(app.dateCreated)), 1),
                          _createElementVNode("td", _hoisted_50, [
                            _createElementVNode("div", _hoisted_51, [
                              _hoisted_52,
                              _createElementVNode("ul", _hoisted_53, [
                                _createElementVNode("li", _hoisted_54, [
                                  _createElementVNode("button", {
                                    class: "dropdown-item text-danger w-100",
                                    onClick: ($event: any) => (confirmDeleteApplication(app.applicationId))
                                  }, [
                                    _hoisted_56,
                                    _createTextVNode("Delete ")
                                  ], 8, _hoisted_55)
                                ])
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_57, [
            _hoisted_58,
            _hoisted_59,
            _hoisted_60,
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (showCreateApplicationModal.value = true))
            }, [
              _hoisted_61,
              _createTextVNode(" Create Your First Application ")
            ])
          ]))
    ])
  ], 64))
}
}

})